/* eslint-disable default-case */
import { PrinterIcon } from '@heroicons/react/outline';
import * as htmlToImage from 'html-to-image';
import { jsPDF } from "jspdf";
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactToPrint from "react-to-print";
import { AuthorityActions, AuthorityModules } from '../api-authorization/ApiAuthorizationConstants';
import authService from '../api-authorization/AuthorizeService';
import { BackButton } from '../controls/BackButton';
import Toast from '../controls/BaseToast';
import { Loading } from '../controls/Loading';
import { OrderStatus, ProductBrandTemplate, ProductCategory } from '../infrastructure/AppConstants';
import { OtherCustomerMadeView } from "./CustomerMade/OtherCustomerMadeView";
import { OtherEarmoldView } from "./eardrum/OtherEarmoldView";
import orderService, { OrderCommitAction, OrderResultStatus } from './OrderService';
import ScanFileDialog from './ScanFileDialog';
import { WidexCustomMade } from './widex/CustomMade';
import { WidexEardrum } from './widex/Eardrum';
import { ConfirmAlert } from '../controls/ConfirmAlert'
import EditInforIdDialog from './EditInforIdDialog'
import { EarmoldSheet } from './eardrum/EarmoldSheet';
import { CustomizedSheet } from './CustomerMade/CustomizedSheet';
import { RejectReasonDialog } from './RejectReasonDialog';
import { OrderRemarkButton } from './OrderRemarkButton';

export class OrderForm extends Component {
    static displayName = OrderForm.name;

    constructor(props) {
        super(props);
        let model = null
        if (props.printMode) {
            model = props.model;
        }
        this.state = { status: -1, model: model, isAllowEdit: false, isAllowExport: false, isAllowRetreat: false, isAllowConfirmOrder: false, editInfoIdDialogOpen: false, buttonContainerWidthStyle: "", confirmOpen: false, printing: false, isAllowEditInforId: false, remark:'' };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleExportPdf = this.handleExportPdf.bind(this);
        this.openUploadScanFile = this.openUploadScanFile.bind(this);
        this.closeScanFileDialog = this.closeScanFileDialog.bind(this);
        this.onReviewClose = this.onReviewClose.bind(this);
        this.onReviewOpen = this.onReviewOpen.bind(this);
        this.handleReview = this.handleReview.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.editInfoIdDialogOpen = this.editInfoIdDialogOpen.bind(this);
        this.editInfoIdDialogClose = this.editInfoIdDialogClose.bind(this);
        this.finishOrderCallBack = this.finishOrderCallBack.bind(this);
        this.onRemarkSubmit = this.onRemarkSubmit.bind(this);
    }

    onRemarkSubmit(remark) {
        //this.setState({ remark: remark });
        var id = this.props.id;
        this.locaData(id);
    }

    async componentDidMount() {
        var id = this.props.id;
        if (id && !this.props.printMode) {
            this.locaData(id);
        }
        const edit = await authService.isAllow(AuthorityModules.Order, AuthorityActions.Edit);
        const exportPdf = await authService.isAllow(AuthorityModules.Order, AuthorityActions.Export);
        const retreat = await authService.isAllow(AuthorityModules.Order, AuthorityActions.Retreat);
        const confirmOrder = await authService.isAllow(AuthorityModules.Order, AuthorityActions.ConfirmOrder);
        const isAllowEditInforId = await authService.isAllow(AuthorityModules.Order, AuthorityActions.EditInforId);
        this.setState({
            isAllowEdit: edit, isAllowExport: exportPdf, isAllowRetreat: retreat, isAllowConfirmOrder: confirmOrder, isAllowEditInforId: isAllowEditInforId
        });
        this.timeObj = setTimeout(this.handleResize, 1000)
        window.addEventListener("resize", this.handleResize);
    }


    handleResize = () => {
        const widthStyle = { width: 'calc(100% - ' + document.getElementById("sidebar").clientWidth + 'px)' }
        //  console.log(widthStyle)
        this.setState({ buttonContainerWidthStyle: widthStyle })
    }
    async locaData(id) {
        var order = await orderService.getOrderInfoFromServer(id);
        this.setState({ model: order, remark: order.remark });

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        clearTimeout(this.timeObj);
    }


    hadleRoleChange(event) {
        event.preventDefault();
        const target = event.target;
        const value = target.value;

        this.setState({
            selectedRoleId: value
        });
    }
    onReviewClose() {
        this.setState({ confirmOpen: false });
    }

    onReviewOpen(e) {
        e.preventDefault();
        this.setState({ confirmOpen: true });
    }

    async handleReview(e) {
        var id = this.props.id;
        const token = await authService.getAccessToken();
        const response = await fetch('order/AuditPass', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify({
                'id': id,
            })
        });
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status == 0) {
                    this.onReviewClose();
                    this.locaData(id);
                }
                else {
                    Toast.warn(data.message);
                }
            }
        }
        else {
            console.error('response.status:' + response.status)
        }

    }
    async handleCancel(e) {
        var id = this.props.id;
        const token = await authService.getAccessToken();
        const response = await fetch('order/Cancel', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify({
                'orderId': id,
            })
        });
        if (response.status == 200) {
            window.history.back(-1);
        }
        else {
            console.error('response.status:' + response.status)
        }

    }

    async handleSubmit(e) {
        e.preventDefault();
        var name = e.target.name;
        var action = OrderCommitAction.Save;
        switch (name) {
            case 'Submit':
                // action = OrderCommitAction.Submit;
                break;
            case 'Retreat':
                action = OrderCommitAction.Retreat;
                break;
        }

        await orderService.commit(action);
        window.history.back(-1);
    }

    async openUploadScanFile(e) {
        e.preventDefault();
        // console.log(this.state.model);
        const order = this.state.model;
        if (order.productBrand == ProductBrandTemplate.Widex) {
            if (order.productCategory == ProductCategory.CustomMade) {
                var result = this.widexCustomMade.onCheck();
                if (!result.status) {
                    Toast.warn(result.message);
                    return;
                }
            } else if (order.productCategory == ProductCategory.Eardrum) {
                var result = this.widexEardrum.onCheck();
                if (!result.status) {
                    Toast.warn(result.message);
                    return;
                }
            }
        }
        else if (order.productBrand == ProductBrandTemplate.WSA) {
            var name = e.target.name;
            var action = OrderCommitAction.Save;
            switch (name) {
                case 'Submit':
                    action = OrderCommitAction.Submit;
                    break;
                case 'Retreat':
                    action = OrderCommitAction.Retreat;
                    break;
            }
            let result = await orderService.commit(action);
            if (result.status == OrderResultStatus.Fail && result.message) {
                Toast.warn(result.message);
                return;
            }
        }
        this.scanFileDialog.open();
    }
    closeScanFileDialog(e) {
        this.scanFileDialog.close();
    }
    editInfoIdDialogOpen(e) {
        e.preventDefault();
        this.setState({ editInfoIdDialogOpen: true });

    }
    finishOrderCallBack() {
        this.locaData(this.props.id);
    }


    handleExportPdf(e) {
        e.preventDefault();
        this.loadingRef.showLoading();
        const name = this.state.model.orderNum + ".pdf";
        const close = this.loadingRef.closeLoading;
        const productCategory = this.state.model.productCategory;
        const productBrand = this.state.model.productBrand;
        let orientation = this.state.model.productBrand == ProductBrandTemplate.Widex ? "portrait" : 'landscape';
        htmlToImage.toCanvas(document.getElementById('orderForm'), {
            filter: function (node) {
                try {
                    if (node.nodeType === 1) {
                        if (node.tagName === "SELECT" && node.selectedIdx != -1) {
                            var options = node.childNodes; // Assumption!
                            var optionCount = 0;
                            var selectedIdx = node.selectedIndex;
                            for (var i = 0; i < options.length; i++) {
                                var option = options[i]; // Maybe not an option
                                if (option.tagName === "OPTION") {
                                    if (optionCount === selectedIdx) {
                                        options[i].setAttribute('selected', true);
                                    }
                                    else {
                                        options[i].removeAttribute('selected');
                                    }
                                    optionCount++;
                                }
                            }
                        }
                    }
                } catch (e) {
                    console.error('toCanvas, filter ex:', e);
                }

                return true;
            }
        })
            .then(function (canvas) {
                try {
                    const imgData = canvas.toDataURL('image/png');
                    const pdf = new jsPDF({
                        orientation: orientation,
                    });
                                        
                    if (productBrand == ProductBrandTemplate.WSA && productCategory == ProductCategory.Eardrum) {
                        const imgProps = pdf.getImageProperties(imgData);
                        const pdfActWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = pdf.internal.pageSize.getHeight();
                        const pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
                        
                        pdf.addImage(imgData, 'PNG', 0, 0, pdfActWidth, pdfHeight);
                    }
                    else if (productBrand == ProductBrandTemplate.WSA && productCategory == ProductCategory.CustomMade) {
                        const imgProps = pdf.getImageProperties(imgData);
                        const pdfActWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = pdf.internal.pageSize.getHeight();
                        const pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
                        
                        pdf.addImage(imgData, 'PNG', 0, 5, pdfActWidth, pdfHeight - 20);
                    }
                    else {
                        const imgProps = pdf.getImageProperties(imgData);
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                    }

                    pdf.save(name);
                }
                catch (e) {
                    console.error('toCanvas, to pdf ex:', e);
                }

                close();
            });
    }
    editInfoIdDialogClose() {
        this.setState({ editInfoIdDialogOpen: false });
    }
    handleBack(e) {
        e.preventDefault();
        window.history.back(-1);
    }

    renderButtonBar(data) {
        if (window.location.search.indexOf("preview") > -1) {
            return null;
        }
        if (data == null || !this.state.buttonContainerWidthStyle) { return null; }
        var attachFile = [];
        if (data.attachmentFile) {
            attachFile = data.attachmentFile.split(',');
        }
        switch (data.status) {
            case OrderStatus.Draft:
            case OrderStatus.Retreat:
                return (
                    <div className="bg-gray-50 text-center w-full fixed bottom-0 py-4" style={this.state.buttonContainerWidthStyle}>
                        {this.state.isAllowEdit && <button name="Save" onClick={this.handleSubmit}
                            className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        ><FormattedMessage id="Save" /></button>}
                        {this.state.isAllowEdit && <button name="Submit" onClick={this.openUploadScanFile}
                            className="inline-block mx-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        ><FormattedMessage id="Submit" /></button>}
                        <BackButton />
                    </div>
                );
            case OrderStatus.Submitted:
                return (<div className="bg-gray-50 text-center fixed bottom-0 w-full  py-4" style={this.state.buttonContainerWidthStyle}>
                    {this.state.isAllowConfirmOrder && <button name="ConfirmOrder" onClick={this.onReviewOpen}
                        className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    ><FormattedMessage id="ConfirmOrder" /></button>}
                    {this.state.isAllowRetreat && <RejectReasonDialog orderStatus={OrderStatus.Retreat} />}
                    {this.state.isAllowRetreat && <RejectReasonDialog orderStatus={OrderStatus.Cancel} />}
                    <BackButton />
                    <OrderRemarkButton orderId={data.id} remark={data.remark} onSubmit={this.onRemarkSubmit } />
                    {this.renderPrintButton(data.productBrand, data.productCategory)}
                    {this.state.isAllowExport && <button name="ExportPdf" onClick={this.handleExportPdf}
                        className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    ><FormattedMessage id="ExportPdf" /></button>}
                    {attachFile.map((item, index) => {
                        return (<a key={index} className="mr-5 text-blue-600 text-sm" href={item}>
                            {index + 1}.{
                                (item.indexOf("?sv") > -1 ? item.substring(item.lastIndexOf('/') + 1, item.indexOf("?sv")) : item.substring(item.lastIndexOf('/') + 1))
                            }</a>)
                    })}
                    <Loading onRef={(ref) => { this.loadingRef = ref }} />
                    <ConfirmAlert onRef={(ref) => { this.confirmRef = ref }} onCancel={this.onReviewClose} onOk={(e) => { this.handleReview(e) }} open={this.state.confirmOpen} messageId="AuditPass" />
                </div>);
            case OrderStatus.Reviewed:
                return (<div className="bg-gray-50 text-center fixed bottom-0 w-full  py-4" style={this.state.buttonContainerWidthStyle}>
                    {this.state.isAllowRetreat && <RejectReasonDialog orderStatus={OrderStatus.Retreat} />}
                    {this.state.isAllowRetreat && <RejectReasonDialog orderStatus={OrderStatus.Cancel} />}
                    {this.state.isAllowExport && <button name="ExportPdf" onClick={this.handleExportPdf}
                        className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    ><FormattedMessage id="ExportPdf" /></button>}
                    <BackButton />
                    <OrderRemarkButton orderId={data.id} remark={data.remark} onSubmit={this.onRemarkSubmit} />
                    {this.renderPrintButton(data.productBrand, data.productCategory)}
                    {attachFile.map((item, index) => {
                        return (<a className="mr-5 text-blue-600 text-sm" href={item}>
                            {index + 1}.{(item.indexOf("?sv") > -1 ? item.substring(item.lastIndexOf('/') + 1, item.indexOf("?sv")) : item.substring(item.lastIndexOf('/') + 1))}</a>)
                    })}
                    <Loading onRef={(ref) => { this.loadingRef = ref }} />
                 
                </div>);
            case OrderStatus.Finish:
                return (<div className="bg-gray-50 text-center fixed bottom-0 w-full  py-4" style={this.state.buttonContainerWidthStyle}>
                    {this.state.isAllowEditInforId && <button name="EditInforId" onClick={this.editInfoIdDialogOpen}
                        className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    ><FormattedMessage id="EditInforId" /></button>}
                    {this.state.isAllowRetreat && <RejectReasonDialog orderStatus={OrderStatus.Cancel} />}
                    
                    {this.state.isAllowExport && <button name="ExportPdf" onClick={this.handleExportPdf}
                        className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    ><FormattedMessage id="ExportPdf" /></button>}
                    <BackButton />
                    <OrderRemarkButton orderId={data.id} remark={data.remark} onSubmit={this.onRemarkSubmit} />
                    {this.renderPrintButton(data.productBrand, data.productCategory)}
                    {attachFile.map((item, index) => {
                        return (<a key={index} className="mr-5 text-blue-600 text-sm" href={item}>{index + 1}.  {
                            (item.indexOf("?sv") > -1 ? item.substring(item.lastIndexOf('/') + 1, item.indexOf("?sv")) : item.substring(item.lastIndexOf('/') + 1))}</a>)
                    })}
                    <Loading onRef={(ref) => { this.loadingRef = ref }} />
                    <EditInforIdDialog onRef={(ref) => { this.editInfoIdDialog = ref }} infoId={this.state.model.infoId} orderNum={this.state.model.orderNum} open={this.state.editInfoIdDialogOpen} callback={this.finishOrderCallBack} onClose={this.editInfoIdDialogClose} />                    
                </div>);
            case OrderStatus.Cancel:
                return (<div className="bg-gray-50 text-center fixed bottom-0 w-full  py-4" style={this.state.buttonContainerWidthStyle}>
                    {this.state.isAllowExport && <button name="ExportPdf" onClick={this.handleExportPdf}
                        className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    ><FormattedMessage id="ExportPdf" /></button>}
                    <BackButton />
                    {this.renderPrintButton(data.productBrand, data.productCategory)}
                    {attachFile.map((item, index) => {
                        return (<a key={index} className="mr-5 text-blue-600 text-sm" href={item}>{index + 1}.  {
                            (item.indexOf("?sv") > -1 ? item.substring(item.lastIndexOf('/') + 1, item.indexOf("?sv")) : item.substring(item.lastIndexOf('/') + 1))}</a>)
                    })}
                    <Loading onRef={(ref) => { this.loadingRef = ref }} />
                </div>);
        }
        return null;
    }
    renderPrintButton(productBrand,productCategory) {
        if (productBrand == ProductBrandTemplate.Widex) {
            return (<ReactToPrint
                trigger={() => <button name="Print"
                    className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                ><FormattedMessage id="Print" /></button>}
                content={() => this.componentRef}
                pageStyle="@page { size: portrait; margin:0px; } "
            />);
        } else {
            if (productCategory == ProductCategory.CustomMade) {
                return (<ReactToPrint
                    trigger={() => <button name="Print"
                        className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    ><FormattedMessage id="Print" /></button>}
                    content={() => this.componentRef}
                    pageStyle="@page { size: landscape; margin:0px; } "                                     
                />)
            } else {
                return (<ReactToPrint
                    trigger={() => <button name="Print"
                        className="mx-2 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    ><FormattedMessage id="Print" /></button>}
                    content={() => this.componentRef}
                    pageStyle="@page { size: landscape; margin:0px; } "
                    onBeforeGetContent={() => {                        
                        return new Promise((resolve) => {
                            this.setState({ printing: true }, () => {
                                resolve();
                            });
                        });
                    }}
                    onAfterPrint={() => {
                        this.setState({ printing: false });
                    }}
                />);
            }
          
        }
    }

    renderOtherCustomerMadeView(data, buttonBar) {
        return (
            <div id="container" className="md:px-1 3xl:px-48 3xl:py-6">
                <OtherCustomerMadeView ref={(el) => (this.componentRef = el)} model={data} printMode={this.props.printMode} remark={this.state.remark} />
                {buttonBar}
            </div>
        );
    }

    OtherEardrumView(data, buttonBar) {
        return (
            <div id="container">
                <OtherEarmoldView ref={(el) => (this.componentRef = el)} model={data} printing={this.state.printing} printMode={this.props.printMode} remark = {this.state.remark} />
                {buttonBar}    
            </div>
        );
    }

    WidexEardrumView(data, buttonBar) {
      //  console.log(data);
        return (
            <div id="container">
                <WidexEardrum ref={(el) => (this.componentRef = el)} model={data} onRef={(ref) => { this.widexEardrum = ref }} printMode={this.props.printMode} />
                {buttonBar}
                <ScanFileDialog onRef={(ref) => { this.scanFileDialog = ref }} leftRightOption={data.leftRightOption} id={this.props.id} onClose={this.closeScanFileDialog}></ScanFileDialog>
            </div>
        );
    }

    WidexCustomerMadeView(data, buttonBar) {
        return (
            <div id="container">
                <WidexCustomMade ref={(el) => (this.componentRef = el)} model={data} onRef={(ref) => { this.widexCustomMade = ref }} printMode={this.props.printMode}/>
                {buttonBar}
                <ScanFileDialog onRef={(ref) => { this.scanFileDialog = ref }} leftRightOption={data.leftRightOption}  id={this.props.id} onClose={this.closeScanFileDialog}></ScanFileDialog>
            </div>
        );
    }

    render() {
        const data = this.state.model;
        if (data == null) {
            return null;
        }
        let buttonBar = this.renderButtonBar(data);
        if (data.productBrand == ProductBrandTemplate.WSA) {

            if (data.productCategory == ProductCategory.Eardrum) {
                if (!(window.location.search.indexOf("preview") > -1) && (data.status === OrderStatus.Draft || data.status == OrderStatus.Retreat || data.status == OrderStatus.DealerReview)) {
                    return <EarmoldSheet model={data} id={this.props.id}/>
                }
               
                return this.OtherEardrumView(data, buttonBar);
            }
            else {
                if (!(window.location.search.indexOf("preview") > -1) && (data.status === OrderStatus.Draft || data.status == OrderStatus.Retreat || data.status == OrderStatus.DealerReview)) {
                    return <CustomizedSheet model={data} id={this.props.id} />
                }
                return this.renderOtherCustomerMadeView(data, buttonBar);
            }
        }
        else if (data.productBrand == ProductBrandTemplate.Widex) {

            if (data.productCategory == ProductCategory.Eardrum) {
                return this.WidexEardrumView(data, buttonBar);
            }
            else {
                return this.WidexCustomerMadeView(data, buttonBar);
            }
        }
    }
}
